export enum OrderItemCategory {
    PRI_KAVICKE = 'PRI_KAVICKE', MATERIALY = 'MATERIALY', WEBINARE = 'WEBINARE', LEKTORI = 'LEKTORI', KURZY = 'KURZY'
}